import ExtendableError from './ExtendableError';

export class ApplicationError extends ExtendableError {
  code: string;
  originalError?: Error;

  constructor(message: string, code: string, originalError?: Error) {
    super(message);
    this.code = code;
    this.originalError = originalError;
  }
}

export const isApplicationError = (error: Error): error is ApplicationError => {
  return (error as ApplicationError).code !== undefined;
};
